<script lang="ts" setup>
  import MainLayout from '@/layouts/MainLayout.vue';
</script>

<template>
  <div id="app-container">
    <MainLayout>
      <router-view />
    </MainLayout>
  </div>
</template>
